export default {
  selection: {
    makeSelectionToShowDetails: {
      notes: 'Shown when no panels are selected in the panel selection view',
      message: 'Make a selection to show additional details.',
    },
    multipleValues: {
      notes: 'Shown when selected panels have different values for a property',
      message: 'Mixed',
    },
  },
  screeningMedia: {
    dialog: {
      title: {
        notes: 'Title for the screening media selection dialog',
        message: 'Select screening media',
      },
    },
    model: {
      apertureSize: {
        notes: 'Screening media property aperture size',
        message: 'Aperture size',
      },
      apertureType: {
        notes: 'Screening media property aperture type',
        message: 'Aperture type',
      },
      articleNumber: {
        notes: 'Screening media property article number',
        message: 'Article number',
      },
      height: {
        notes: 'Screening media property height',
        message: 'Height',
      },
      materialType: {
        notes: 'Screening media property material type',
        message: 'Material type',
      },
      measurementSystem: {
        notes: 'Screening media property measurement system',
        message: 'Measurement system',
        values: {
          metric: {
            notes: 'Metric units',
            message: 'Metric',
          },
          us: {
            notes: 'US units',
            message: 'US Customary',
          },
        },
      },
      quantity: {
        notes: 'Screening media property quantity',
        message: 'Quantity',
      },
      width: {
        notes: 'Screening media property width',
        message: 'Width',
      },
      workingDepth: {
        notes: 'Screening media property working depth',
        message: 'Working depth',
      },
    },
  },
};
